module.exports = __webpack_public_path__ + "static/media/icon2.32cf955d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon2.jpg
// module id = 130
// module chunks = 0